import React from "react";
import { connect } from "react-redux";
import { fromJS } from "immutable";
import { createDoc } from "../../../reducers/docs/actions";
import { Form, TYPE_INFO } from "../../../lib";
import styled from "styled-components";

const Container = styled.div`
    margin: 0 auto 60px auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
`;

const mapDispatch = { createDoc };
type DispatchProps = typeof mapDispatch;
type Props = DispatchProps & {};

type State = {
    doc: ReturnType<typeof fromJS>;
};

class CreateBook extends React.Component<Props, State> {
    state = {
        doc: fromJS({
            name: "بلاعنوان",
        }),
    };

    order = ["name"];

    fields = {
        name: {
            type: "text",
        },
    };

    constraints = {
        name: {
            presence: { message: "nameRequired" },
            length: {
                minimum: 3,
                message: "nameMinChars",
            },
        },
    };

    onSubmit = (values: any) => {
        this.props.createDoc({
            ...values,
            status: "PUBLISHED",
            visibility: "PUBLIC",
            redirect: false,
        });

        const { gtag } = window;
        gtag("event", "doc", {
            event_label: "create",
        });
    };

    render() {
        return (
            <Container>
                <Form
                    id="doc"
                    updateProp="doc"
                    doc={this.state.doc}
                    order={this.order}
                    fields={this.fields}
                    constraints={this.constraints}
                    focusOnFirst={true}
                    editing="Create"
                    primaryBtnType={TYPE_INFO}
                    onSubmit={this.onSubmit}
                />
            </Container>
        );
    }
}

export default connect(null, mapDispatch)(CreateBook);
